<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações do Pedido de Venda</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configurações que valem para todos os pedidos de venda.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="48%" marginTop="12"></app-loading-box>
        <app-loading-box height="22" width="52%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="160" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="12"></app-loading-box>
        <app-loading-box height="22" width="50%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="52%" marginTop="16"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="180" marginTop="0"></app-loading-box>
        <app-loading-box height="150" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        <!-- ================= Exibição ================= -->
        <div class="section-container" id="exibicao">
          <div class="section-title">
            <mat-icon>visibility</mat-icon>
            <span>Exibição</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact"
                  formControlName="isAlertaEnderecoIncompleto">Exibir alerta quando o endereço do cliente
                  estiver incompleto</mat-slide-toggle>
                <span class="info-text">Avisa ao salvar o pedido se o cadastro do cliente não tiver endereço
                  completo.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isAlertaComissaoZerada">Exibir
                  alerta quando comissão estiver zerada</mat-slide-toggle>
                <span class="info-text">Quando vendedor estiver selecionado e a comissão de todos os itens
                  estiver zerada.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isVisualizarContasReceber">Permitir
                  a visualização das contas a receber em aberto nos pedidos e notas
                  fiscais</mat-slide-toggle>
                <span class="info-text">Mostra, dentro do próprio pedido, as contas em aberto ou em atraso do
                  cliente.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isExibirTagStatusPagamento">Exibir
                  tag com status do pagamento do pedido de venda</mat-slide-toggle>
                <span class="info-text">Adiciona um marcador visual — Pago, Em atraso — refletindo a situação
                  financeira.</span>
              </div>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <label class="bloco-titulo">Seções detalhadas do pedido</label>

                <div class="grupo-exibicao">
                  <label class="grupo-exibicao-label">Exibir detalhes da venda nos pedidos</label>
                  <mat-radio-group formControlName="idTipoExibicaoDetalhesVenda" class="radio-grupo-linha">
                    @for (t of opcoesTipoExibicaoSecaoPedido; track t.idTipoExibicaoSecaoPedido) {
                    <mat-radio-button [value]="t.idTipoExibicaoSecaoPedido">{{ t.descricao }}</mat-radio-button>
                    }
                  </mat-radio-group>
                </div>

                <div class="grupo-exibicao">
                  <label class="grupo-exibicao-label">Exibir dados adicionais nos pedidos</label>
                  <mat-radio-group formControlName="idTipoExibicaoDadosAdicionais" class="radio-grupo-linha">
                    @for (t of opcoesTipoExibicaoSecaoPedido; track t.idTipoExibicaoSecaoPedido) {
                    <mat-radio-button [value]="t.idTipoExibicaoSecaoPedido">{{ t.descricao }}</mat-radio-button>
                    }
                  </mat-radio-group>
                </div>

                <div class="grupo-exibicao">
                  <label class="grupo-exibicao-label">Exibir transportador nos pedidos</label>
                  <mat-radio-group formControlName="idTipoExibicaoTransportador" class="radio-grupo-linha">
                    @for (t of opcoesTipoExibicaoSecaoPedido; track t.idTipoExibicaoSecaoPedido) {
                    <mat-radio-button [value]="t.idTipoExibicaoSecaoPedido">{{ t.descricao }}</mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Impressão ================= -->
        <div class="section-container mt-4" id="impressao">
          <div class="section-title">
            <mat-icon>print</mat-icon>
            <span>Impressão</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirCodigoBarras">Imprimir
                  número do pedido em código de barras</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirDescComplementar">Imprimir
                  descrição complementar dos produtos</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirCabecalhoProducao">Imprimir
                  cabeçalho na impressão de pedidos para produção</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirCamposAssinatura">Incluir
                  campos de data e assinatura para comprovação de entrega</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirEnderecoEmpresa">Imprimir
                  endereço da empresa</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirImagemProdutos">Imprimir
                  imagem dos produtos na impressão detalhada</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirNomeFantasia">Imprimir
                  nome fantasia ao invés de razão social</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isCalcularImpostos">Calcular
                  impostos nas vendas</mat-slide-toggle>
                <span class="info-text">Habilita o cálculo automático de tributos na criação do pedido.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirImpostosItens">Imprimir
                  impostos dos itens na impressão detalhada</mat-slide-toggle>
                @if (!form.get('isCalcularImpostos')?.value) {
                <span class="info-text">{{ impostosDesabilitadoApoio }}</span>
                }
              </div>

              @if (mostrarImpostos) {
                <div class="bloco-indentado">
                  <app-impostos-impressos-selecao
                    [impostos]="opcoesTipoImpostoImpressao"
                    [value]="impostosSelecionados"
                    (valueChange)="onImpostosChange($event)">
                  </app-impostos-impressos-selecao>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- ================= Regras e bloqueios ================= -->
        <div class="section-container mt-4" id="regras-bloqueios">
          <div class="section-title">
            <mat-icon>gavel</mat-icon>
            <span>Regras e bloqueios</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isVendedorObrigatorio">Vendedor
                  obrigatório</mat-slide-toggle>
                <span class="info-text">O pedido só pode ser salvo com um vendedor informado.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isBloquearClienteAtraso">Bloquear
                  emissão de pedidos cujo cliente possua contas em atraso</mat-slide-toggle>
                <span class="info-text">Vale para pedidos criados manualmente. Pedidos vindos de API, aplicativo
                  ou PDV não são bloqueados por esta regra.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact"
                  formControlName="isBloquearSemFormaRecebimento">Bloquear emissão de pedidos sem forma de
                  recebimento e condições de pagamento</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isConsiderarPesoEmbalagens">Considerar
                  peso das embalagens no peso bruto da venda</mat-slide-toggle>
                <span class="info-text">Soma o peso das embalagens de envio ao peso bruto usado no cálculo de
                  frete.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact"
                  formControlName="isBloquearExclusaoOcorrencia">Bloquear a exclusão de ocorrência das
                  vendas</mat-slide-toggle>
                <span class="info-text">Impede que o histórico de ocorrências do pedido seja apagado.</span>
              </div>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <div class="bloco-titulo bloco-titulo-inline">
                  <span>Bloquear emissão de pedidos com estoques que não podem ser atendidos</span>
                  <mat-icon class="material-symbols-outlined info-icon" [matTooltip]="bloqueioEstoqueTooltip"
                    matTooltipPosition="above">info</mat-icon>
                </div>
                <mat-radio-group formControlName="isBloquearEstoqueInsuficiente" class="radio-grupo-linha">
                  <mat-radio-button [value]="true">Sim</mat-radio-button>
                  <mat-radio-button [value]="false">Não</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Lançamento de estoque para fabricado</mat-label>
                      <mat-select formControlName="idTipoLancamentoEstoqueFabricado">
                        @for (t of opcoesTipoLancamentoEstoqueFabricado;
                        track t.idTipoLancamentoEstoqueFabricado) {
                        <mat-option [value]="t.idTipoLancamentoEstoqueFabricado">{{ t.descricao }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <div class="hint-text">Como o estoque de produtos fabricados é baixado na venda.</div>
                  </div>

                  <div class="col-12 col-md-6 mt-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Quantidade de volumes padrão</mat-label>
                      <input matInput type="number" class="no-spinner" min="0" step="1"
                        formControlName="quantidadeVolumesPadrao">
                      @if (volumesInvalido) {
                      <mat-error>{{ volumesErro }}</mat-error>
                      }
                    </mat-form-field>
                    <div class="hint-text">Pré-preenche o campo Volumes de todo novo pedido.</div>
                  </div>

                  <div class="col-12 col-md-6 mt-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Depósito para devoluções de vendas</mat-label>
                      <mat-select formControlName="idTipoDepositoDevolucao">
                        @for (t of opcoesTipoDepositoDevolucao; track t.idTipoDepositoDevolucao) {
                        <mat-option [value]="t.idTipoDepositoDevolucao">{{ t.descricao }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <div class="hint-text">Para onde o estoque retorna quando uma devolução é processada.</div>
                  </div>

                  @if (mostrarDepositoEspecifico) {
                    <div class="col-12 col-md-6 mt-3">
                      <app-select-pesquisavel
                        [control]="depositoEspecificoControl"
                        label="Qual depósito"
                        [offlineList]="opcoesLocalizacao"
                        idField="id"
                        nameField="descricao">
                      </app-select-pesquisavel>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Observações ================= -->
        <div class="section-container mt-4" id="observacoes">
          <div class="section-title">
            <mat-icon>notes</mat-icon>
            <span>Observações</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <label class="bloco-titulo">Observação padrão dos pedidos de venda</label>
              <div class="editor-container editor-observacao">
                <ngx-editor-menu [editor]="editorObservacao" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor [editor]="editorObservacao" formControlName="observacaoPadrao"
                  placeholder="Escreva a observação padrão dos pedidos de venda...">
                </ngx-editor>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading || !configCarregada"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
